<template>
  <div>
    <!-- Feed first. It used to sit below Segments, on the reasoning that WHO we can reach decides
         whether the rest is worth doing — true for Google, but the feed now serves Meta too, and
         Meta builds its own audience from the pixel and never touches Segments at all. So the feed
         is the one part of this page both platforms depend on, and the only part of the Meta
         integration that lives here. -->
    <CatalogFeed />
    <Segments />
    <!-- Creative last: it is the only part that can't be reasoned about until you know who you can
         reach and what inventory the ad can point at. -->
    <AdCreative />
  </div>
</template>

<script>
import Segments from '@/components/marketing/retargeting/Segments';
import CatalogFeed from '@/components/marketing/retargeting/CatalogFeed';
import AdCreative from '@/components/marketing/retargeting/AdCreative';

export default {
  name: 'RetargetingIndex',

  components: {
    Segments,
    CatalogFeed,
    AdCreative
  }
};
</script>
